
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/libros/[slug]",
      function () {
        return require("private-next-pages/libros/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/libros/[slug]"])
      });
    }
  